AcademiaSharing.UndoTracker = function () {
  UndoTracker.prototype.cookie_name = 'autobookmark_undo';
  function UndoTracker() {
    this.consecutive_undos = parseInt($.cookie(this.cookie_name) || 0);
    $.removeCookie(this.cookie_name, this.cookie_settings());
    this;
  }
  UndoTracker.prototype.increment = function () {
    return $.cookie(this.cookie_name, this.consecutive_undos + 1, this.cookie_settings());
  };
  UndoTracker.prototype.cookie_settings = function () {
    return {
      path: '/',
      domain: "." + $domain,
      expires: $a.days_from_now(7)
    };
  };
  return UndoTracker;
}();